/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";
import Image from "next/image";
import { useMemo } from "react";
import classNames from "classnames";
import { communityLink, productList } from "./constants";
import "./styles.scss";

export default function FooterPc() {
  const footerClass = useMemo(() => {
    return classNames({
      "footer-warp": true,
      // "footer-warp-light": true,
    });
  }, []);

  return (
    <div className={footerClass}>
      <div className="footer basic-column">
        <div className="block-head">
          <div className={"fellou-logo relative"}>
            <Image
              src="/logo.svg"
              alt="fellou"
              fill
              priority
              unoptimized
            />
          </div>
          <a
            href="mailto:hi@fellou.ai"
            className="contact-email"
            onClick={async () => {
              try {
                await navigator.clipboard.writeText("hi@fellou.ai");
              } catch (err) {
                console.log(err);
              }
            }}
          >
            Contact Us | hi@fellou.ai
          </a>
          <div className="icons-link">
            {communityLink.map((item, index) => {
              return (
                <div
                  key={`${item.type}-${index}`}
                  className="icon-link"
                  rel="noopener noreferrer"
                  data-log={item.log}
                  onClick={() => {
                    window.open(item.path, "_blank");
                  }}
                >
                  <i className={item.icon}></i>
                </div>
              );
              // }
            })}
          </div>
        </div>
        <div className="block">
          <div className="block-title">Product</div>
          {productList[0].map((item: any, index) => {
            return (
              <a
                key={index}
                className="title"
                href={item.other ? item.other : item.path}
                target={item.toway === 0 ? "_blank" : "_self"}
                rel="noopener noreferrer"
              >
                {item.title}
              </a>
            );
          })}
        </div>
        <div className="block">
          <div className="block-title">Framework</div>
          {productList[1].map((item: any, index) => {
            return (
              <a
                key={index}
                className="title"
                href={item.other ? item.other : item.path}
                target={item.toway === 0 ? "_blank" : "_self"}
                rel="noopener noreferrer"
              >
                {item.title}
              </a>
            );
          })}
        </div>
        <div className="block">
          <div className="block-title">Company</div>
          {productList[2].map((item: any, index) => {
            return (
              <a
                key={index}
                className="title"
                href={item.other ? item.other : item.path}
                target={item.toway === 0 ? "_blank" : "_self"}
                rel="noopener noreferrer"
              >
                {item.title}
              </a>
            );
          })}
        </div>
        <div className="block">
          <div className="block-title">Legal</div>
          {productList[3].map((item: any, index) => {
            return (
              <a
                key={index}
                className="title"
                href={item.other ? item.other : item.path}
                target={item.toway === 0 ? "_blank" : "_self"}
                rel="noopener noreferrer"
              >
                {item.title}
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}
